"use strict";

exports.__esModule = true;
exports["default"] = contentMigration;
exports.INITIAL_STATE = void 0;

var _fetchStatus = require("../actions/fetch-status");

var _rollback = require("../actions/rollback");

var _setRedirects = require("../actions/set-redirects");

var _migrationStatus = require("../constants/migration-status");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var INITIAL_STATE = {
  status: _migrationStatus.MIGRATION_STATUS_NOT_STARTED
};
exports.INITIAL_STATE = INITIAL_STATE;

function contentMigration(state, action) {
  if (state === void 0) {
    state = INITIAL_STATE;
  }

  switch (action.type) {
    case _rollback.CONTENT_MIGRATION_ROLLBACK_SUCCESS:
    case _fetchStatus.CONTENT_MIGRATION_FETCH_STATUS_SUCCESS:
    case _setRedirects.CONTENT_MIGRATION_SET_REDIRECTS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), action.payload);

    default:
      return state;
  }
}